import { render, staticRenderFns } from "./LeadsExternalMarketingAutomationManageItem.vue?vue&type=template&id=63f06e10&scoped=true"
import script from "./LeadsExternalMarketingAutomationManageItem.vue?vue&type=script&lang=js"
export * from "./LeadsExternalMarketingAutomationManageItem.vue?vue&type=script&lang=js"
import style0 from "./LeadsExternalMarketingAutomationManageItem.vue?vue&type=style&index=0&id=63f06e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f06e10",
  null
  
)

export default component.exports